import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';
import ResizeDetector from 'react-resize-detector';

import AppMain from '../AppMain/index';

class Main extends React.Component {
  render() {
    let { darkTheme } = this.props;

    return (
      <ResizeDetector
        handleWidth
        render={({ width }) => (
          <Fragment>
            <div
              className={cx('app-container app-theme-gray', {
                'dark-theme': darkTheme,
              })}
            >
              <AppMain />
            </div>
          </Fragment>
        )}
      />
    );
  }
}

const mapStateToProp = () => ({});

export default withRouter(connect(mapStateToProp)(Main));
